(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
customElements.whenDefined('details-disclosure').then(() => {

  class NavMenu extends DetailsDisclosure {
    constructor() {
      super();

      if (this.matches('.js-mega-nav')) {
        this.reset();
        window.addEventListener('resize', this.reset.bind(this));
      }
    }

    reset() {
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;

      // Desktop → always open (mega menu style)
      if (isDesktop) {
        this.disclosure.open = true;
        this.toggle.setAttribute('tabindex', '-1');
      } else {
        this.disclosure.open = false;
        this.toggle.removeAttribute('tabindex');
      }
    }

    handleToggle(e) {
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;

      // Desktop → click disable (hover use hoga)
      if (isDesktop) {
        e.preventDefault();
        return;
      }

      // Mobile → default behavior (IMPORTANT)
      super.handleToggle(e);
    }
  }

  customElements.define('nav-menu', NavMenu);
});


// ✅ Hover ONLY for desktop (NO click override)
document.querySelectorAll('.child-nav--dropdown li nav-menu details').forEach(function(detail) {

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  detail.addEventListener('mouseenter', function() {
    if (isDesktop()) {
      detail.open = true;
    }
  });

  detail.addEventListener('mouseleave', function() {
    if (isDesktop()) {
      detail.open = false;
    }
  });

});

  } catch(e) { console.error(e); }
})();
})();
